import { render, staticRenderFns } from "./wordEditorTier.vue?vue&type=template&id=14c12321&scoped=true&"
import script from "./wordEditorTier.vue?vue&type=script&lang=js&"
export * from "./wordEditorTier.vue?vue&type=script&lang=js&"
import style0 from "./wordEditorTier.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./wordEditorTier.vue?vue&type=style&index=1&id=14c12321&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c12321",
  null
  
)

export default component.exports